<template>
    <or-layout>
        <h3 class="page">
            <a-tag color="blue">{{ taskInfo.typename || '未设置' }}</a-tag>
            {{ taskInfo.name }}
            <a-button type="primary" style="float: right" icon="left" @click="goPage">返回</a-button>
        </h3>
        <div class="class">
            <a-form layout="inline">
                <a-form-item>
                    <a-select v-model="campusId" class="select" placeholder="校区">
                        <a-select-option :value="null">所有校区</a-select-option>
                        <template v-for="item in campusData">
                            <a-select-option :key="item.id" :value="item.id">{{ item.name }}</a-select-option>
                        </template>
                    </a-select>
                </a-form-item>
                <a-form-item>
                    <a-input v-model="managerName" placeholder="班主任或老师姓名" />
                </a-form-item>
                <a-form-item>
                    <a-input v-model="classname" placeholder="班级名称" />
                </a-form-item>
                <a-form-item>
                    <a-button type="primary" icon="search" @click="loadClassData">搜索</a-button>
                </a-form-item>
            </a-form>
            <!-- <h4 class="header">班级统计</h4> -->
            <a-table class="table" :data-source="classData" :row-key="item => item.id" :pagination="false"
                :loading="loading" bordered>
                <a-table-column key="name" title="班级名称">
                    <template slot-scope="item">
                        {{ item.campusname }}
                        {{ item.gradename }}
                        {{ item.name }}
                    </template>
                </a-table-column>
                <a-table-column key="manager" title="班主任/任课老师">
                    <template slot-scope="item">
                        <span>{{ item.banzhuren }}</span>
                        <span>/</span>
                        <span>{{ item.teacher }}</span>
                    </template>
                </a-table-column>
                <a-table-column key="count" title="实测 / 应测 / 总数"
                    :sorter="(item1, item2) => item1.squadinfo.shiceusercount - item2.squadinfo.shiceusercount">
                    <template slot-scope="item">
                        {{ item.squadinfo.shiceusercount }} / {{ item.statistic }} / {{ item.actual }}
                    </template>
                </a-table-column>
                <a-table-column key="persent" title="参测率"
                    :sorter="(item1, item2) => item1.squadinfo.ccl - item2.squadinfo.ccl">
                    <template slot-scope="item">
                        {{ (item.squadinfo.ccl * 100).toFixed(2) }} %
                    </template>
                </a-table-column>
                <a-table-column key="avg" title="平均分" :sorter="(item1, item2) => item1.squadinfo.pjf - item2.squadinfo.pjf">
                    <template slot-scope="item">
                        {{ item.squadinfo.pjf.toFixed(2) }}
                    </template>
                </a-table-column>
                <a-table-column key="action" title="操作">
                    <template slot-scope="item">
                        <show-grade-mission-student :item="{ squad_id: item.id, mission_id: taskId }" />
                        <!--<a @click="show_grade_list(item.id)">详情</a>-->
                    </template>
                </a-table-column>
            </a-table>
        </div>
        <a-modal :centered="true" :footer="null" :width="1000" :visible="grade_mission_list_visible" :destroyOnClose="true"
            :confirmLoading="loading" :maskClosable="false" :keyboard="false" title="班级任务详情"
            @cancel="grade_mission_list_visible = false">
            <a-table :dataSource="grade_mission_list" :rowKey="item => item.id" :pagination="false" :loading="loading">
                <a-table-column data-index="nickname" key="nickname" title="学生姓名" />
                <a-table-column data-index="count" key="count" title="总数" />
                <a-table-column data-index="right" key="right" title="正确" />
                <a-table-column data-index="error" key="error" title="错误" />
                <a-table-column data-index="myscore" key="myscore" title="分数" />
                <a-table-column :width="120" key="del" title="操作">
                    <template slot-scope="item">

                        <!--<show-student-mission  v-if="item.count>0" :item="item">111</show-student-mission>-->
                        <!--<a-button v-if="item.count>0" :loading="loading"-->
                        <!--@click="show_student_answer_detail(item.id,item.squad_id)">答题详情-->
                        <!--</a-button>-->
                        <a-button v-if="item.count == 0" :loading="loading">未答题</a-button>
                    </template>
                </a-table-column>
            </a-table>
            <div style="text-align: right;margin-top: 1rem;">
                <a-button type="primary" @click="grade_mission_list_visible = false">关闭</a-button>
            </div>
        </a-modal>
        <a-modal :centered="true" :footer="null" :width="1000" :visible="student_answer_detail_visible"
            :destroyOnClose="true" :confirmLoading="loading" :maskClosable="false" :keyboard="false" title="学生答题详情"
            @cancel="student_answer_detail_visible = false">
            <a-table :dataSource="student_answer_detail_list" :rowKey="item => item.id" :pagination="false"
                :loading="loading">
                <a-table-column key="title" :width="500" title="题目">
                    <template slot-scope="item">
                        <span v-html="item.title" />
                    </template>
                </a-table-column>
                <a-table-column data-index="answer" key="answer" title="参考答案" />
                <a-table-column key="user_answer" title="学生答案">
                    <template slot-scope="item">
                        <img class="previewer-img" :src="item.user_answer" style="max-width:100px;" />
                        <video controls :src="item.user_answer" v-if="item.typestr == 'VIDEO'" />
                    </template>
                </a-table-column>
                <a-table-column key="comment" :width="200" title="评语">
                    <template slot-scope="item">
                        <span>{{ item.comment }}</span>
                        <audio v-if="item.audio_path != ''" :src="item.audio_path" />
                    </template>
                </a-table-column>

            </a-table>
            <div style="text-align: right;margin-top: 1rem;">
                <a-button type="primary" @click="student_answer_detail_visible = false">关闭</a-button>
            </div>
        </a-modal>

    </or-layout>
</template>

<script>
import ShowGradeMissionStudent from "@/components/show_grade_mission_student";

export default {
    data() {
        return {
            taskId: "",
            loading: false,
            taskInfo: {},
            campusData: [],
            classData: [],
            campusId: undefined,
            managerName: undefined,
            classname: undefined,
            currentGradeId: "",
            //增加班级任务信息
            grade_mission_list_visible: false,
            grade_mission_list: [],
            student_answer_detail_visible: false,
            student_answer_detail_list: [],
        };
    },
    mounted() {
        this.currentGradeId = this.$route.query.currentGradeId;
        this.taskId = this.$route.query.tid;
        this.loadTaskInfo();
        this.loadClassData();
        this.loadCampusData();
    },
    methods: {
        cclstore(item, item2) {
            return item.squadinfo.ccl - item2.squadinfo.ccl;
        },
        show(index) {
            // 显示特定index的图片，使用ref
            this.$refs.previewer.show(index);
        },
        async show_grade_list(squad_id) {
            this.loading = true;
            const res = await this.$axios.post("/api/BasicMission/get_mission_problems_squad_report", {
                data: {
                    mission_id: this.taskId,
                    squad_id: squad_id,
                },
            });
            this.grade_mission_list = res.data;
            this.loading = false;
            this.grade_mission_list_visible = true;
        },
        async show_student_answer_detail(user_id, squad_id) {
            this.loading = true;
            const res = await this.$axios.post("/api/BasicMission/get_user_problemslist", {
                data: {
                    mission_id: this.taskId,
                    squad_id: squad_id,
                    user_id: user_id
                },
            });
            this.student_answer_detail_list = res.data;
            this.loading = false;
            this.student_answer_detail_visible = true;
        },

        goPage() {
            this.$router.push({
                path: '/orgorganizationinfo',
                query: { id: this.$route.query.oid, currentGradeId: this.currentGradeId }
            });
        },
        async loadTaskInfo() {
            const res = await this.$axios.post('/api/QuestionProblems/getproblemsbymissionlist', { data: { mission_id: this.$route.query.tid } })
            this.taskInfo = res.data.info;
        },
        async loadClassData() {
            this.loading = true;
            const res = await this.$axios.post("/api/BasicMission/getmissionreportinfo", {
                data: {
                    mission_id: this.$route.query.tid,
                    org_id: this.$route.query.oid,
                    campus_id: this.campusId,
                    teachername: this.managerName,
                    squadname: this.classname
                },
            });
            this.classData = res.data;
            this.loading = false;
        },
        async loadCampusData() {
            const res = await this.$axios.post('/api/OrgCampus/getorgcampuslist', { data: { org_id: this.$route.query.oid } });
            this.campusData = res.data;
        }
    },
    components: {
        ShowGradeMissionStudent
    }
};
</script>

<style lang="less" scoped>
.select {
    width: 120px;
}

.table {
    margin-top: 1.5rem;
}

.duration {
    font-size: 0.75rem;
    font-weight: 200;
    color: #999;
    margin-left: 0.5rem;
}

.statistics {
    display: flex;
    align-items: center;
    margin-top: 1rem;

    .item {
        width: 5rem;
        margin-right: 1rem;

        .value {
            font-size: 1.5rem;
            font-weight: 500;
            text-align: center;
        }

        .label {
            color: #999;
            font-size: 0.75rem;
            text-align: center;
            font-weight: 200;
        }
    }
}

.entries {
    margin-top: 1.5rem;

    .header {
        color: #999;
    }

    .item {
        margin-bottom: 1rem;
        border: 1px solid #e8e8e8;
        border-radius: 4px;
        padding: 1rem;

        .title {
            font-weight: 500;
        }

        .options {
            margin-top: 0.875rem;
            display: flex;
            align-items: center;

            .option-item {
                display: flex;
                align-items: center;
                width: 25%;

                .label {
                    color: #999;
                }

                .value {
                    margin-left: 0.75rem;
                }
            }
        }

        .meta {
            margin-top: 1rem;
            display: flex;
            align-items: center;
            justify-content: space-between;
        }
    }
}

.class {
    margin-top: 1.5rem;

    .header {
        color: #999;
    }
}
</style>